import * as types from "../mutation-type"
import axios from "axios/index";


export default {
  state: {
    formatConversion: {
      info:[]
    },
    dataVisualization: {
      info:[]
    },
    dataPostProcessing: {
      info:[]
    },
  },
  mutations: {
    [types.SET_FORMAT_CONVERSION](state, payload) {
      state.formatConversion.info = payload.info
    },
    [types.SET_DATA_VISUALIZATION](state, payload) {
      state.dataVisualization.info = payload.info
    },
    [types.SET_DATA_POST_PROCESSING](state, payload) {
      state.dataPostProcessing.info = payload.info
    },

  },
  actions: {
    getFormatConversion({dispatch, commit}) {

      let url = process.env.VUE_APP_API_URL + "utility/list/format-conversion"
      //console.log(url)
      return axios.get(url).then(function(response){

        let data = response.data.data
        //console.log(data)
        commit({
          type: types.SET_FORMAT_CONVERSION,
          info: data
        })
      }).catch(err => {
        console.log(err)
      })
    },
    getDataVisualization({dispatch, commit}) {

      let url = process.env.VUE_APP_API_URL + "utility/list/data-visualization"
      //console.log(url)
      return axios.get(url).then(function(response){

        let data = response.data.data
        //console.log(data)
        commit({
          type: types.SET_DATA_VISUALIZATION,
          info: data
        })
      }).catch(err => {
        console.log(err)
      })
    },
    getDataPostProcessing({dispatch, commit}) {

      let url = process.env.VUE_APP_API_URL + "utility/list/data-post-processing"
      //console.log(url)
      return axios.get(url).then(function(response){

        let data = response.data.data
        //console.log(data)
        commit({
          type: types.SET_DATA_POST_PROCESSING,
          info: data
        })
      }).catch(err => {
        console.log(err)
      })
    },

  }
}
